export enum EventResolveOnEnum {
  HT = 1,
  FT = 2,
  REALTIME = 3,
  Q1 = 4,
  Q2 = 5,
  Q3 = 6,
  Q4 = 7,
  Q5 = 8,
  OVERTIME = 9,
  S1 = 10,
  S2 = 11,
  S3 = 12,
  S4 = 13,
  S5 = 14,
  ON_SET = 15,
  ON_GEM = 16
}

export enum EventTypeEnum {
  LIVE = 1,
  PRE_MATCH = 2
}

export enum EventStatusEnum {
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  FINISHED = 3,
  CANCELLED = 4,
  POSTPONED = 5,
  INTERRUPTED = 6,
  ABANDONED = 7,
  COVERAGE_LOST = 8,
  ABOUT_TO_START = 9,
  DISABLED = 10,
  FEED_BLOCKED = 11,
  IN_PROGRESS_OVERTIME = 12,
  RESULT_RESET = 13,
  RETIRED = 14,
  PLAYER_NOT_PARTICIPATE = 15,
  REMOVE_FROM_REVISION = 16,
  INVALID_EVENT = 17,
  RESOLVED = 18
}

export enum EventManuallyResolveEnum {
  NONE = 0,
  PASSED = 1,
  FAILED = 2,
  Q1 = 3
}

export enum EventManuallyResolveReasonEnum {
  ABANDONED = 1,
  POSTPONED = 2,
  PLAYER_NOT_PARTICIPATE = 3,
  SWAP,
  RETIRED
}

export enum ExternalEventsParsersEnum {
  DEFAULT_PARSER = 1,
  QP_PARSER = 2
}






